export default {
  title: {
    id: 'product_comparison_buying_guides_title',
    defaultMessage: 'Our featured articles',
  },
  cardNext: {
    id: 'buying_guide_slider_next_slide',
    defaultMessage: 'Display next slide',
  },
  cardPrev: {
    id: 'buying_guide_slider_prev_slide',
    defaultMessage: 'Display previous slide',
  },
}
